import React, { useState, useRef, useEffect } from "react";
import { handleValidation } from "../../../utils/validationInput";
import {
  FieldError,
  FieldErrors,
  Path,
  UseFormRegister,
  Control
} from "react-hook-form";

interface Props {
  onSelectAddress: (addressObject: google.maps.places.PlaceResult) => void;
  type: string;
  label: Path<any>;
  fieldName: string;
  required: boolean;
  error?: FieldError | FieldErrors;
  style?: React.CSSProperties;
  readOnly?: boolean;
  defaultValue?: string | undefined;
}

const INPUT_COLOR = "#D0D0D0";
const INPUT_COLOR_ERROR = "red";

export default function AddressAutocomplete({
  onSelectAddress,
  type,
  label,
  fieldName,
  required,
  error,
  style,
  readOnly,
  defaultValue,
}: Props) {
  const handlePlaceSelect = () => {
    const addressObject = autoComplete.getPlace();
    onSelectAddress(addressObject);
  };

  const [scriptLoaded, setScriptLoaded] = useState(false);
  const autoCompleteRef = useRef<HTMLInputElement | null>(null);
  let autoComplete: google.maps.places.Autocomplete;

  useEffect(() => {
    if (!scriptLoaded) {
      const script = document.createElement("script");
      //script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAR_uQnLNy7GzL3E7GwZ-g-hC8AHl1JTYE&libraries=places`;
      script.async = true;
      script.onload = () => {
        setScriptLoaded(true);
      };
      document.head.appendChild(script);
    }
  }, [scriptLoaded]);

  useEffect(() => {
    if (scriptLoaded) {
      // Crea el objeto de autocompletado de Google Maps
      autoComplete = new google.maps.places.Autocomplete(
        autoCompleteRef.current!,
        { types: ["geocode"] }
      );

      // Cuando un lugar es seleccionado, llama a handlePlaceSelect
      autoComplete.addListener("place_changed", handlePlaceSelect);

    }
  }, [scriptLoaded]);

  return (
    <div className="box">
      <input
        type={type}
        ref={autoCompleteRef}
        readOnly={readOnly}
        className="input"
        placeholder=" "
        name={fieldName}
        style={{
          cursor: "pointer",
          borderColor: `${error ? INPUT_COLOR_ERROR : INPUT_COLOR}`,
          ...style,
        }}
        defaultValue={defaultValue}
      />
      {/* LABEL */}
      {label && <span className="label">{label}</span>}

      {/* ERRORS MESSAGE */}
      {error?.message && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
      )}
      {error?.type === "required" && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{label} es requerido*</span>
      )}
    </div>
  );
}